import {BASE_AGGREGATION} from 'pipelines/formula/functions/BaseFunctions';

import {AnalysisFunction} from '../FunctionTypes';

export default {
  ...BASE_AGGREGATION,
  name: 'SE',
  description:
    'Standard error of all numbers in a single column OR across each row of multiple columns. Single numbers are treated as columns containing only that number.',
  shortDescription: 'Standard error',
} satisfies AnalysisFunction;
